import { useState } from "react"
import fallback from '../../assets/fallback.png'
import { getCurrentPath } from "../../utils/helpers"
import { InfoElement, infos } from "../../utils/data"
import { InfoCircleOutlined, EyeOutlined } from '@ant-design/icons'
import { Avatar, Drawer, Image, Skeleton, Typography } from "antd"

function Informations(): JSX.Element {
  const [open, setOpen] = useState(false);
  const [info, setInfo] = useState<InfoElement | null>();
  const [loading, setLoading] = useState(false);
  const onOpen = () => {
    let searchedInfo = infos.find(i => i.origin === getCurrentPath())
    if (searchedInfo) {
      setInfo(searchedInfo)
      setOpen(true)
    }
  }

  const onClose = () => {
    setOpen(false)
    setInfo(null)
  }

  return (
    <>
      <Avatar onClick={onOpen} className="info" shape="circle" icon={<InfoCircleOutlined />} />
      {
        info &&
        <Drawer id="informations" title={info.title} onClose={onClose} open={open}>
          {
            info.asset &&
            (
              info.asset.type === 'image' ?
                <>
                  {
                    loading &&
                    <Skeleton.Image style={{ height: 200, width: "100%" }} active />
                  }
                  <Image
                    preview={{ mask: (<span><EyeOutlined />&nbsp;Ouvrir</span>) }}
                    onLoad={() => setLoading(false)}
                    style={{ display: loading ? 'none' : 'block' }}
                    fallback={fallback}
                    src={info.asset.source}
                  />
                </>
                :
                <video width="100%" height="auto" controls src={info.asset.source} />
            )
          }
          {
            loading ?
              <Skeleton title={false} paragraph={{ rows: 4 }} active />
              :
              <Typography style={{ marginTop: 10 }}>
                <div dangerouslySetInnerHTML={{ __html: info.description }} />
              </Typography>
          }
        </Drawer>
      }
    </>
  )
}

export default Informations
